<template>
  <div class="record">
    <div class="record-container">
      <div class="top-banner">
        <van-nav-bar 
          left-text="返回" 
          title="充值记录"
          left-arrow 
          @click-left="onClickLeft"
        >
        </van-nav-bar>
        <van-tabs
          title-active-color="#ffffff" 
          title-inactive-color="#f0f0f0"
          v-model="activeTab"
          @change="tabChange"
        >
          <!-- <van-tab title="流量" name="traffic"></van-tab> -->
          <van-tab title="红包" name="red_pack"></van-tab>
          <!-- <van-tab title="短信" name="sms"></van-tab> -->
        </van-tabs>
      </div>
      <div class="content">
        <div class="record-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loadBusy" infinite-scroll-distance="30">
        <van-pull-refresh v-model="loadBusy" @refresh="onRefresh" style="min-height: 100%">
          <template v-if="list.length > 0">
            <div class="record-item" v-for="record in list" :key="record.type + '-' + record.id">
              <div class="item-header">
                流水号：{{ record.tradeno }}
              </div>
              <div class="info" v-if="[105, 109].includes(record.status)">
                <li>操作渠道：后台提现</li>
                <li v-if="record.type == 'red_pack'">提现额度：{{ (record.amount / 100).toFixed(0) }} 元</li>
                <li>操作日期：{{ record.created_at }}</li>
              </div>
              <div class="info" v-if="[5, 9].includes(record.status)">
                <li>充值渠道：{{ record.user_id ? '后台充值' : '自助充值' }} 
                  <span v-if="record.status == 5" style="color: red">(处理中)</span>
                </li>
                <li v-if="record.type == 'sms'">充值额度：{{ record.amount }} 条</li>
                <li v-if="record.type == 'traffic'">充值额度：{{ (record.amount / 1000 / 1000 / 1000).toFixed(1) }} G</li>
                <li v-if="record.type == 'red_pack'">充值额度：{{ (record.amount / 100).toFixed(0) }} 元</li>
                <li>充值日期：{{ record.created_at }}</li>
              </div>
            </div>
          </template>
          <template v-else>
            <van-empty description="暂无更多内容" />
          </template>
        </van-pull-refresh>
        </div>
      </div>
    </div>
    <DisError />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import DisError from './component/DisError.vue';
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { queryChargeRecord, groupMasterUpdate } from '@/api/distributor'

export default {
  name: 'DisChargeRecord',
  components: {
    Footer, DisError
  },
  data() {
    return {
      loadBusy: false,
      page: 1,
      activeTab: 'red_pack',
      total_page: 0,
      list: [],
      meta: {
        type: 'red_pack',
        page: 1,
      },
      showEdit: false,
      editId: undefined,
      editForm: {
        real_name: '',
        mobile: '',
      },
    }
  },
  computed: {
    ...mapState(['user']),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loadData()
    },
    tabChange(evt) {
      console.log('tabChange', evt)
      this.loadData({
        page: 1,
        type: evt,
      })
    },
    onRefresh() {
      this.loadData({
        page: 1,
        type: this.meta.type,
      })
    },
    loadData({ page = 1, type = 'red_pack' } = {}) {
      this.loadBusy = true;
      queryChargeRecord(type, {
        page,
      }).then((resp) => {
        let { current_page, data, total } = resp.data
        this.page = current_page
        this.total_page = total
        
        this.list = current_page == 1 ? data : this.list.concat(data)
        this.loadBusy = false
        this.meta = {
          page,
          type,
        }
      })
    },
    loadMore() {
      if (this.meta.page -1 < this.total_page) {
        this.loadData({
          page: this.meta.page + 1,
          type: this.meta.type
        })
      }
    },
    onClickLeft() {
      this.$router.back();
    },
  }
}
</script>
<style lang="scss" scoped>
.record-container {
  height: calc(100vh);
  width: 100%;
  display: flex;
  flex-direction: column;
  .top-banner {
    flex: 0 0 48px;
    background: #4fc08d;
  }
  .content {
    flex: 1 1 auto;
    width: 100%;
    overflow: hidden;
    background: #e3e3e3;
    .record-list {
      height: 100%;
      width: 100%;
      // background: red;
      overflow-y: scroll;
      padding: 10px;
      .record-item {
        position: relative;
        padding: 10px;
        background: #fff;
        width: 100%;
        margin-bottom: 12px;
        min-height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        
        .info {
          padding: 8px 0 0 0;
        }
        li {
          list-style: none;
          line-height: 1.6em;
        }

        .item-header {
          padding: 3px;
          color: #aaa;
          border-bottom: 1px solid #ccc;
        }

        .action {
          display: flex;
          .btn {
            width: 150px;
            line-height: 28px;
            font-size: 16px;
            border: 1px solid #ccc;
            text-align: center;
            border-left: none;
            &:first-child {
              border-left: 1px solid #ccc;
            }
          }
        }
        
      }
    }
  }
}
.video_container {
  width: 90vw;
  height: 52vw;
  video {
    width: 100%;
  }
}
</style>
